import { ClientError, Status } from 'nice-grpc-web';

export interface IApiError {
  kind: 'invalid' | 'denied' | 'unauthenticated' | 'network' | 'other';
  message: string;
}

const KINDS: Partial<Record<Status, IApiError['kind']>> = {
  [Status.INVALID_ARGUMENT]: 'invalid',
  [Status.PERMISSION_DENIED]: 'denied',
  [Status.UNAUTHENTICATED]: 'unauthenticated',
};

/** The service is unreachable: UNAVAILABLE, or the failed fetch nice-grpc-web reports as "Transport error: …". */
const isNetworkFailure = (error: ClientError) =>
  error.code === Status.UNAVAILABLE || (error.code === Status.UNKNOWN && error.details.startsWith('Transport error'));

export function toApiError(error: unknown): IApiError {
  if (error instanceof ClientError)
    return { kind: isNetworkFailure(error) ? 'network' : (KINDS[error.code] ?? 'other'), message: error.details };
  return { kind: 'other', message: error instanceof Error ? error.message : String(error) };
}

/** The service refused because of the item state (e.g. a version card that already exists). */
export const isFailedPrecondition = (error: unknown): boolean =>
  error instanceof ClientError && error.code === Status.FAILED_PRECONDITION;
